import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.9041 5.794C21.9031 5.795 21.9021 5.797 21.9011 5.798L12.4051 18.794C12.4051 18.794 12.4051 18.794 12.4041 18.794C12.3741 18.835 12.3371 18.873 12.2931 18.905C12.0701 19.067 11.7571 19.018 11.5951 18.794H11.5941L2.09412 5.794C1.93312 5.57 1.98312 5.258 2.20612 5.095C2.29512 5.031 2.39812 5 2.50012 5H21.5001C21.6021 5 21.7051 5.031 21.7941 5.095C22.0171 5.258 22.0671 5.57 21.9041 5.794V5.794Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'RoundedTriangleDownFill');

export default Icon;
